import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsVoxComponent } from './simple-icons-vox.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsVoxComponent ],
    exports:      [ SimpleIconsVoxComponent ],
    bootstrap:    []
})
export class SimpleIconsVoxModule {}
